import type { TFunction } from 'i18next';

/**
 * Maps the English `title` field from DemoFan data files to an i18n key.
 * Data files stay pure English; consumers call `translateFanTitle` at render
 * time to pick up the current locale.
 */
const FAN_TITLE_KEYS: Record<string, string> = {
  'Music Specialist': 'fan.titleMusicSpecialist',
  'Rock Rebel': 'fan.titleRockRebel',
  'Pop Architect': 'fan.titlePopArchitect',
  'Electronic Alchemist': 'fan.titleElectronicAlchemist',
  'Country Storyteller': 'fan.titleCountryStoryteller',
  'Latin Fire': 'fan.titleLatinFire',
  'Indie Dreamer': 'fan.titleIndieDreamer',
  'Jazz Sophisticate': 'fan.titleJazzSophisticate',
};

/**
 * Maps the English `placeholder` field from DemoFan data files to an i18n key.
 */
const FAN_PLACEHOLDER_KEYS: Record<string, string> = {
  'Describe your hip-hop song...': 'fan.placeholderHipHop',
  'Describe your rock song...': 'fan.placeholderRock',
  'Describe your R&B song...': 'fan.placeholderRnB',
  'Describe your pop song...': 'fan.placeholderPop',
  'Describe your electronic song...': 'fan.placeholderElectronic',
  'Describe your country song...': 'fan.placeholderCountry',
  'Describe your urbano song...': 'fan.placeholderUrbano',
  'Describe your indie song...': 'fan.placeholderIndie',
  'Describe your jazz song...': 'fan.placeholderJazz',
  'Describe your Mexican song...': 'fan.placeholderMexican',
  'Describe your Bollywood song...': 'fan.placeholderBollywood',
};

export const translateFanTitle = (title: string | undefined, t: TFunction): string => {
  if (!title) return '';
  const key = FAN_TITLE_KEYS[title];
  return key ? t(key) : title;
};

export const translateFanPlaceholder = (
  placeholder: string | undefined,
  t: TFunction,
): string => {
  if (!placeholder) return '';
  const key = FAN_PLACEHOLDER_KEYS[placeholder];
  return key ? t(key) : placeholder;
};
